/* eslint-disable */
import axios, { AxiosRequestConfig }  from 'axios'

class AxiosWithInterceptor {
  private token: string | undefined = JSON.parse(localStorage.getItem('currentUser') as string)?.token

  private endpoint: string = 'https://workspace.mimon.com.br:5000/'  // 'http://localhost:2003/'

  private config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(this.token && { Authorization: 'Bearer ' + this.token })
    },
    baseURL: this.endpoint
  }

  instance = axios.create(this.config)

  constructor() {
    this.instance.defaults.timeout = 1000000
  }

  SetHeaderToken(token: string) {
    if (!token) 
      throw 'Empty token'
    
    this.token = token

    this.instance.interceptors.request.use((config: AxiosRequestConfig) => {
      config.headers['Authorization'] = `Bearer ${this.token}`
      return config
    })
  }
}

const axiosWithInterceptor = new AxiosWithInterceptor()

export default axiosWithInterceptor
